var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:("button_link button_link_" + _vm.variant),attrs:{"href":_vm.link}},[(_vm.icon)?_c('span',{class:("icon icon-icon-" + _vm.icon)}):_vm._e(),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }